import { z } from 'zod';
import { itemLegacySchema } from './item/item-legacy-dto';

export const loopViewItemsResponseSchema = z.object({
  items: z.array(itemLegacySchema),
});

export type LoopViewItemsResponseDTO = z.infer<typeof loopViewItemsResponseSchema>;
